export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "ora";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min fa`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} h fa`;
  const days = Math.floor(h / 24);
  return `${days} g fa`;
}

export function whenLabel(w) {
  return { today: "Oggi", this_week: "In settimana", whenever: "Quando capita",
    oggi: "Oggi", domani: "Domani", in_settimana: "In settimana", da_concordare: "Da concordare" }[w] || w;
}

export function distanceLabel(km) {
  if (km == null) return "";
  if (km < 1) return "meno di 1 km";
  return `${Math.round(km)} km`;
}

export function money(v, currency = "EUR") {
  if (v == null) return "";
  try {
    return new Intl.NumberFormat("it-IT", { style: "currency", currency, maximumFractionDigits: 0 }).format(v);
  } catch {
    return `${v} €`;
  }
}
